import OAuth2 from '../services/liferay.js';

// Pension API client for retirement calculations
const BASE_URL = '/o/restService/prs-calculator';
const oauth = new OAuth2();

async function postJson(path, payload, options = {}) {
  const controllerSignal = options.signal;
   const headers = await oauth.getHeaders();
   //headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
  const res = await fetch(`${BASE_URL}${path}`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(payload),
    signal: controllerSignal,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `Request failed with status ${res.status}`);
  }
  return res.json();
}

export async function calculateRC(payload, options) {
  // Expected payload keys: TargetRetirementAmount, dob, RetirementAge, InterestRate
  return postJson('/CalculateRetirementContribution', payload, options);
}

export async function calculateRA(payload, options) {
  // Expected payload keys: MonthlyContribution, dob, RetirementAge, InterestRate, InitialAmount, AnnualIncreaseRate
  return postJson('/CalculateRetirementAmount', payload, options);
}


